//src/ContactUs.tsx hardened/refactored v1

import React from "react";
import StickyHeader from "./StickyHeader";
import StickyFooter from "./StickyFooter";

const ContactUs: React.FC = () => (
  // Apply a gradient background to the main container
  <div className="flex flex-col min-h-screen bg-gradient-to-br from-pink-200 via-rose-200 to-orange-200">
    <StickyHeader />

    <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="py-12">
        {/* 
          Updated Card Styling:
          - bg-white/70 makes the background 70% opaque, letting the page background show through.
          - backdrop-blur-lg adds a blur effect to the background behind the card.
          - ring-1 ring-black/5 adds a subtle border.
        */}
        <div className="max-w-3xl mx-auto p-8 rounded-lg shadow-xl bg-white/70 backdrop-blur-lg ring-1 ring-black/5">
          <h1 className="text-3xl font-bold text-pink-900 border-b border-pink-300 pb-4 mb-6">
            Contact Us
          </h1>
          <p className="text-lg text-gray-800 mb-6">
            We value your feedback and are here to help. Please use the
            information below to get in touch with our team for support,
            questions, or business inquiries.
          </p>

          {/* Contact Information Section */}
          <div>
            <h2 className="text-2xl font-bold text-pink-900 mb-4">
              Contact Information
            </h2>
            <div className="space-y-3 text-lg text-gray-900">
              <p>
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:customersupport@crushhh.com"
                  className="text-rose-600 hover:underline"
                >
                  customersupport@crushhh.com
                </a>
              </p>
              <p>
                <strong>Business Address:</strong> CRUSHHH INC, 5830 E 2ND
                ST, STE 7000, CASPER, WY 82609
              </p>
            </div>
          </div>

          {/* Response Time Section */}
          <div className="mt-8 pt-6 border-t border-pink-300">
            <p className="text-base text-gray-700">
              We aim to respond to all inquiries within 2 business days.
            </p>
            <p className="text-base text-gray-700 mt-2">
              For privacy-related requests, please see our{" "}
              <a href="/privacy" className="text-rose-600 hover:underline">
                Privacy Policy
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </main>

    <StickyFooter />
  </div>
);

export default ContactUs;
